import React from "react";
import adam1 from "../../assets/images/adam1PNG.png";
import adam2 from "../../assets/images/adsam2PNG.png";
import heroIc from "../../assets/images/heroIc1.png";
import SearchInput from "../../components/SearchInput";
import plusIcon from "../../assets/images/plus.svg";
import { Tooltip } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import "../homePage/heroSection.css";
import { useLanguage } from "../../context/LanguageContext";

const HeroSection: React.FC = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  const handleClickComplain = (id: number) => {
    navigate(`/complain/${id}`);
  };

  return (
    <div className="bg-gradient-to-r from-[#D0D0D080] to-white py-10">
      <div className="flex flex-col lg:flex-row items-center justify-center lg:gap-x-20 gap-y-10 lg:gap-y-0 px-4">
        {/* mans */}
        {/* <div className="flex flex-col md:flex-row gap-x-10 lg:gap-x-24 flex-[1] justify-center lg:justify-end">
          <div className=" relative">
            <div className=" absolute bottom-0 md:bottom-[20px] lg:bottom-[10px] left-16 md:left-14 lg:left-[75px]">
              <Tooltip
                content="Bilek Ağrıları"
                style="light"
                className=" min-w-[150px] flex justify-center items-center text-center min-h-[60px]"
              >
                <div className="image-container">
                  <img
                    onClick={() => handleClickComplain(8)}
                    src={plusIcon}
                    alt="plusIcon"
                    className="cursor-pointer"
                  />
                </div>
              </Tooltip>
            </div>

            <div className="absolute  bottom-36 sm:bottom-48 lg:bottom-56 xl:bottom-64 2xl:bottom-72 left-16 lg:left-20 xl:left-24">
              <Tooltip
                content="Kalça ve Kasık Ağrıları"
                style="light"
                className=" min-w-[150px] flex justify-center items-center text-center min-h-[60px]"
              >
                <div className="image-container">
                  <img
                    onClick={() => handleClickComplain(7)}
                    src={plusIcon}
                    alt="plusIcon"
                    className="cursor-pointer"
                  />
                </div>
              </Tooltip>
            </div>

            <div className="absolute  bottom-[330px] sm:bottom-[320px] md:bottom-[330px] lg:bottom-[390px] xl:bottom-[450px] 2xl:bottom-[470px] left-12 lg:left-16 xl:left-20">
              <Tooltip
                content="Kol ve Omuz Ağrıları"
                style="light"
                className=" min-w-[150px] flex justify-center items-center text-center min-h-[60px]"
              >
                <div className="image-container">
                  <img
                    onClick={() => handleClickComplain(6)}
                    src={plusIcon}
                    alt="plusIcon"
                    className="cursor-pointer"
                  />
                </div>
              </Tooltip>
            </div>

            <div className="absolute  bottom-[370px] sm:bottom-[370px] lg:bottom-[440px] xl:bottom-[490px] 2xl:bottom-[530px] left-[120px] sm:left-[130px] lg:left-36 xl:left-44">
              <Tooltip
                content="Baş ve Boyun Ağrıları"
                style="light"
                className=" min-w-[150px] flex justify-center items-center text-center min-h-[60px]"
              >
                <div className="image-container">
                  <img
                    onClick={() => handleClickComplain(9)}
                    src={plusIcon}
                    alt="plusIcon"
                    className="cursor-pointer"
                  />
                </div>
              </Tooltip>
            </div>

            <img src={adam1} alt="adam1" className="w-56 lg:w-80 min-w-56" />
          </div>
          <div className="  relative">
            <div className=" absolute bottom-0 lg:bottom-32 left-2 md:left-20">
              <Tooltip
                content="Ayak ve Diz Ağrıları"
                style="light"
                className=" min-w-[150px] flex justify-center items-center text-center min-h-[60px]"
              >
                <div className="image-container">
                  <img
                    onClick={() => handleClickComplain(5)}
                    src={plusIcon}
                    alt="plusIcon"
                    className="cursor-pointer"
                  />
                </div>
              </Tooltip>
            </div>

            <div className="absolute bottom-28 lg:bottom-44 xl:bottom-48 2xl:bottom-56 left-2 lg:left-4 xl:left-6">
              <Tooltip
                content="Baldır ve Bacak Ağrıları"
                style="light"
                className=" min-w-[150px] flex justify-center items-center text-center min-h-[60px]"
              >
                <div className="image-container">
                  <img
                    onClick={() => handleClickComplain(4)}
                    src={plusIcon}
                    alt="plusIcon"
                    className="cursor-pointer"
                  />
                </div>
              </Tooltip>
            </div>

            <div className="absolute  bottom-[230px] sm:bottom-[220px] lg:bottom-[270px] xl:bottom-[320px] 2xl:bottom-[360px] left-8 lg:left-12 xl:left-16">
              <Tooltip
                content="Karın ve Göğüs Ağrıları"
                style="light"
                className=" min-w-[150px] flex justify-center items-center text-center min-h-[60px]"
              >
                <div className="image-container">
                  <img
                    onClick={() => handleClickComplain(1)}
                    src={plusIcon}
                    alt="plusIcon"
                    className="cursor-pointer"
                  />
                </div>
              </Tooltip>
            </div>

            <div className="absolute  bottom-[290px] sm:bottom-[280px] lg:bottom-[330px] xl:bottom-[400px] 2xl:bottom-[410px] left-6 lg:left-8 xl:left-10">
              <Tooltip
                content="El ve Kol Ağrıları"
                style="light"
                className=" min-w-[150px] flex justify-center items-center text-center min-h-[60px]"
              >
                <div className="image-container">
                  <img
                    onClick={() => handleClickComplain(2)}
                    src={plusIcon}
                    alt="plusIcon"
                    className="cursor-pointer"
                  />
                </div>
              </Tooltip>
            </div>

            <img src={adam2} alt="adam2" className="w-44 lg:w-60 min-w-44" />
          </div>
        </div> */}
        <div className="flex flex-col md:flex-row gap-x-10 lg:gap-x-24 flex-[1] justify-center lg:justify-end">
          <div className=" relative">
            <div className=" absolute bottom-0 md:bottom-[20px] lg:bottom-[10px] left-16 md:left-14 lg:left-[70px] xl:left-[85px]">
              <Tooltip
                content={t('mans', 'complain1')}
                style="light"
                className=" min-w-[150px] flex justify-center items-center text-center min-h-[60px]"
              >
                <div className="">
                  <img
                    loading="lazy"
                    onClick={() => handleClickComplain(8)}
                    src={plusIcon}
                    alt="plusIcon"
                    className="cursor-pointer"
                  />
                </div>
              </Tooltip>
            </div>

            <div className=" absolute bottom-32 lg:bottom-36 xl:bottom-44 left-14 lg:left-16 xl:left-24">
              <Tooltip
                content={t('mans', 'complain2')}
                style="light"
                className=" min-w-[150px] flex justify-center items-center text-center min-h-[60px]"
              >
                <div className="">
                  <img
                    onClick={() => handleClickComplain(5)}
                    src={plusIcon}
                    alt="plusIcon"
                    className="cursor-pointer"
                  />
                </div>
              </Tooltip>
            </div>

            {/* <div className="absolute  bottom-36 sm:bottom-48 lg:bottom-56 xl:bottom-64 2xl:bottom-72 left-16 lg:left-20 xl:left-24">
              <Tooltip
                content="Kalça ve Kasık Ağrıları"
                style="light"
                className=" min-w-[150px] flex justify-center items-center text-center min-h-[60px]"
              >
                <div className="image-container">
                  <img
                    onClick={() => handleClickComplain(7)}
                    src={plusIcon}
                    alt="plusIcon"
                    className="cursor-pointer"
                  />
                </div>
              </Tooltip>
            </div> */}

            <div className="absolute  bottom-[330px] sm:bottom-[320px] md:bottom-[330px] lg:bottom-[390px] xl:bottom-[460px] 2xl:bottom-[470px] left-8 lg:left-12 xl:left-14">
              <Tooltip
                content={t('mans', 'complain3')}
                style="light"
                className=" min-w-[150px] flex justify-center items-center text-center min-h-[60px]"
              >
                <div className="">
                  <img
                    onClick={() => handleClickComplain(6)}
                    src={plusIcon}
                    alt="plusIcon"
                    loading="lazy"
                    className="cursor-pointer"
                  />
                </div>
              </Tooltip>
            </div>

            <div className="absolute  bottom-[250px] sm:bottom-[250px] lg:bottom-[300px] xl:bottom-[360px] 2xl:bottom-[360px] left-16 lg:left-16 xl:left-24  ">
              <Tooltip
                content={t('mans', 'complain10')}
                style="light"
                className=" min-w-[150px] flex justify-center items-center text-center min-h-[60px]"
              >
                <div className="">
                  <img
                    onClick={() => handleClickComplain(3)}
                    src={plusIcon}
                    alt="plusIcon"
                    loading="lazy"
                    className="cursor-pointer"
                  />
                </div>
              </Tooltip>
            </div>

            <div className="absolute  bottom-[350px] sm:bottom-[340px] lg:bottom-[410px] xl:bottom-[470px] 2xl:bottom-[490px] left-[100px] sm:left-[100px] lg:left-28 xl:left-32 2xl:left-36">
              <Tooltip
                content={t('mans', 'complain4')}
                style="light"
                className=" min-w-[150px] flex justify-center items-center text-center min-h-[60px]"
              >
                <div className="">
                  <img
                    onClick={() => handleClickComplain(9)}
                    src={plusIcon}
                    alt="plusIcon"
                    loading="lazy"
                    className="cursor-pointer"
                  />
                </div>
              </Tooltip>
            </div>

            <img src={adam1} loading="lazy" alt="adam1" className="w-56 lg:w-80 min-w-56" />
          </div>

          <div className="  relative">
            <div className=" absolute bottom-16 lg:bottom-24 xl:bottom-32 left-16 lg:left-[70px] xl:left-20">
              <Tooltip
                content={t('mans', 'complain2')}
                style="light"
                className=" min-w-[150px] flex justify-center items-center text-center min-h-[60px]"
              >
                <div className="">
                  <img
                    onClick={() => handleClickComplain(5)}
                    src={plusIcon}
                    loading="lazy"
                    alt="plusIcon"
                    className="cursor-pointer"
                  />
                </div>
              </Tooltip>
            </div>

            <div className="absolute bottom-36 lg:bottom-44 xl:bottom-48 2xl:bottom-56 left-4 lg:left-6 xl:left-6">
              <Tooltip
                content={t('mans', 'complain5')}
                style="light"
                className=" min-w-[150px] flex justify-center items-center text-center min-h-[60px]"
              >
                <div className="">
                  <img
                    onClick={() => handleClickComplain(4)}
                    src={plusIcon}
                    loading="lazy"
                    alt="plusIcon"
                    className="cursor-pointer"
                  />
                </div>
              </Tooltip>
            </div>

            <div className="absolute  bottom-[230px] sm:bottom-[220px] lg:bottom-[290px] xl:bottom-[320px] 2xl:bottom-[360px] left-0 lg:left-2 xl:left-2">
              <Tooltip
                content={t('mans', 'complain6')}
                style="light"
                className=" min-w-[150px] flex justify-center items-center text-center min-h-[60px]"
              >
                <div className="">
                  <img
                    onClick={() => handleClickComplain(1)}
                    src={plusIcon}
                    loading="lazy"
                    alt="plusIcon"
                    className="cursor-pointer"
                  />
                </div>
              </Tooltip>
            </div>

            <div className="absolute  bottom-[190px] sm:bottom-[220px] lg:bottom-[230px] xl:bottom-[320px] 2xl:bottom-[290px] left-16 lg:left-20 xl:left-24">
              <Tooltip
                content={t('mans', 'complain7')}
                style="light"
                className=" min-w-[150px] flex justify-center items-center text-center min-h-[60px]"
              >
                <div className="">
                  <img
                    onClick={() => handleClickComplain(7)}
                    src={plusIcon}
                    loading="lazy"
                    alt="plusIcon"
                    className="cursor-pointer"
                  />
                </div>
              </Tooltip>
            </div>

            <div className="absolute  bottom-[290px] sm:bottom-[280px] lg:bottom-[330px] xl:bottom-[400px] 2xl:bottom-[410px] left-6 lg:left-8 xl:left-10">
              <Tooltip
                content={t('mans', 'complain8')}
                style="light"
                className=" min-w-[150px] flex justify-center items-center text-center min-h-[60px]"
              >
                <div className="  ">
                  <img
                    onClick={() => handleClickComplain(2)}
                    src={plusIcon}
                    loading="lazy"
                    alt="plusIcon"
                    className="cursor-pointer"
                  />
                </div>
              </Tooltip>
            </div>

            <div className="absolute  bottom-[330px] sm:bottom-[320px] md:bottom-[330px] lg:bottom-[390px] xl:bottom-[420px] 2xl:bottom-[470px] left-20 lg:left-20 xl:left-24">
              <Tooltip
                content={t('mans', 'complain9')}
                style="light"
                className=" min-w-[150px] flex justify-center items-center text-center min-h-[60px]"
              >
                <div className="">
                  <img
                    onClick={() => handleClickComplain(6)}
                    src={plusIcon}
                    loading="lazy"
                    alt="plusIcon"
                    className="cursor-pointer"
                  />
                </div>
              </Tooltip>
            </div>

            <img src={adam2} alt="adam2" loading="lazy" className="w-44 lg:w-60 min-w-44" />
          </div>
        </div>

        {/* text */}
        <div className="flex-1 w-full flex flex-col items-center lg:items-start text-center lg:text-left h-full">
          <div className="font-poppins font-extrabold text-3xl lg:text-5xl flex flex-col gap-y-1 w-full">
            <div className="w-full space-y-3 ">
              <p className=" relative w-full">
                {t('heroSection', 'text1')}
                <div className="absolute -top-10 lg:-top-16 left-[375px] hidden lg:flex">
                  <img loading="lazy" src={heroIc} alt="..." className="w-24" />
                </div>
              </p>
              <p className="text-yellow-color">{t('heroSection', 'text2')}</p>
              <p>{t('heroSection', 'text3')}</p>
            </div>

            <div className="mt-8 ml-2">
              <p className="text-sm flex flex-wrap justify-center lg:justify-start gap-x-1 text-yellow-color font-poppins font-semibold">
                {t('heroSection', 'subText')}{" "}
                {/* <span className=" text-black font-normal">
                  çözümünü bulalım
                </span>{" "} */}
              </p>
            </div>
          </div>

          <div className=" w-full sm:w-7/12 xl:w-1/2 mt-8 z-20">
            <SearchInput type="user" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
